module.exports = __webpack_public_path__ + "img/p3_10.c146771a.png";